import moment from 'moment';
const findJobByProtocol = (protocol) => (job) =>
  job && job.protocol === protocol;

const getters = {
  contactRegistred(state) {
    const existActiveJob =
      state.activeJob && Object.keys(state.activeJob).length > 1;
    if (existActiveJob && state.activeJob.hasOwnProperty('contact')) {
      const { contact } = state.activeJob;

      if (Object.keys(contact).length) {
        return true;
      }

      return false;
    }
    return false;
  },

  paramsFieldScript(state, getters) {
    const { activeJob } = getters;
    const channel = activeJob ? activeJob.channel.toLowerCase() : false;
    if (activeJob) {
      const params = {
        script_id:
          activeJob && activeJob.activeAttendance
            ? activeJob.campaign?.script_id
            : activeJob.queue?.script_id,
      };

      if (activeJob.contact.id) {
        params.contact_id = activeJob.contact.id;
      } else {
        if (activeJob && channel === 'whatsapp') {
          params.contact_identifier = activeJob.contactIdentifier;
        }

        if (activeJob && channel === 'voice') {
          params.contact_identifier = activeJob.phone;
        }

        if (activeJob && channel == 'chat') {
          params.contact_identifier = activeJob.contactIdentifier;
        }
      }
      return params;
    }
    return {};
  },

  existQueueScript(state, getters) {
    const { activeJob } = getters;

    if (activeJob) return activeJob.queue && !!activeJob.queue?.script_id;

    return false;
  },

  existCampaignScript(state, getters) {
    const { activeJob } = getters;
    if (activeJob) return activeJob.campaign && !!activeJob.campaign?.script_id;

    return false;
  },

  activeJob(state) {
    if (state.activeJob) {
      return state.jobList.find(findJobByProtocol(state.activeJob));
    }
    return null;
  },

  getJobByProtocol(state) {
    return (protocol) => state.jobList.find(findJobByProtocol(protocol));
  },

  activeJobIsVoiceChannel(state) {
    if (!state.activeJob) return false;

    const job = state.jobList.find(findJobByProtocol(state.activeJob));

    if (job) return job.channel && job.channel == 'voice';

    return false;
  },

  amountJobsByChannel(state) {
    let amount = {};
    const jobs = state.jobList.filter((job) => job && !job.disabled);
    jobs.forEach((job) => {
      const channel = job.channel?.toLowerCase();

      if (
        (channel == 'whatsapp' && job?.metaType == 'whatsapp') ||
        (channel == 'whatsapp' && job?.metaType == undefined)
      ) {
        amount.whatsapp = amount.whatsapp ? amount.whatsapp + 1 : 1;
      }
      if (channel == 'whatsapp' && job?.metaType == 'instagram') {
        amount.instagram = amount.instagram ? amount.instagram + 1 : 1;
      }

      if (channel !== 'whatsapp') {
        if (amount[channel]) {
          amount[channel] = amount[channel] + 1;
        } else {
          amount[channel] = 1;
        }
      }
    });
    return amount;
  },

  triggeredByAgent(state) {
    return (newJob) =>
      state.manualActivations.find(
        (activation) => activation.whatsapp == newJob.contactIdentifier,
      );
  },

  amountInboxJobs(state) {
    return state.inboxJobs.length;
  },

  unattendedMessages(state) {
    return (protocol) =>
      state.unattendedMessages.filter(
        (message) => message.protocol == protocol,
      );
  },
  inboxMessagesAmount: (state) => (inboxJobProtocol) => {
    const inboxJobFound = state.inboxJobs.find(
      (inboxJob) => inboxJob.protocol == inboxJobProtocol,
    );
    return inboxJobFound === undefined ? 0 : inboxJobFound.messages;
  },
  whatsappSessionTime: (state) => (currentDateTime) => {
    const jobFound = state.jobList.find(findJobByProtocol(state.activeJob));
    const messagesFromContact = jobFound.messages.filter(
      (message) => message.from == jobFound.contactIdentifier,
    );

    if (messagesFromContact.length > 0) {
      const lastMessage =
        messagesFromContact[messagesFromContact.length - 1].time;

      let dateTime = lastMessage.split(' ');
      let lastMessageDate = dateTime[0].split('-');
      let lastMessageTime = dateTime[1].split(':');

      let lastMessageDateTime = new Date(
        lastMessageDate[0],
        lastMessageDate[1] - 1,
        lastMessageDate[2],
        lastMessageTime[0],
        lastMessageTime[1],
        lastMessageTime[2],
      );

      var currentDateMoment = new moment(currentDateTime);
      var lastMessageDateMoment = new moment(lastMessageDateTime);
      var duration = moment.duration(
        currentDateMoment.diff(lastMessageDateMoment),
      );

      if (duration.days() <= 0) {
        let sessionTotalTime = new Date(null, null, null, 23, 59, 59);
        let totalSeconds =
          duration.hours() * 60 * 60 +
          duration.minutes() * 60 +
          duration.seconds();
        let sessionTimeLeft = moment(sessionTotalTime).subtract(
          totalSeconds,
          'seconds',
        );
        return sessionTimeLeft.format('HH:mm:ss');
      }
    }
    return 'expired';
  },

  getMessageById: (state, getters) => (messageId) => {
    const activeJob = getters.activeJob;
    if (!activeJob || !activeJob.messages) return null;

    return activeJob.messages.find(
      (message) =>
        message.id === messageId || message.apiMessageId === messageId,
    );
  },

  getLastMessage: (state) => (protocol) => {
    return state.lastMessages[protocol] || '';
  },
};

export default getters;
